
import { defineComponent } from 'vue'
import { BlobService } from '@/services/partners/Blob.sevice'

export default defineComponent({
  name: 'PreviewPdf',
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
    toolBar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      objectUrl: null as string | null,
    }
  },
  async mounted() {
    if (!this.fileUrl) return
    const pdfBlob = await BlobService.downloadPdfAsBlob(this.fileUrl)
    this.objectUrl = URL.createObjectURL(pdfBlob)
  },
})
